import React from 'react';
import axios from 'axios';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm'

import { useTimeModal } from '../Components/TimeModal/TimeModalContext';

import Loading from '../Components/Loading';
import styles from '../Styles/DynamicModal.module.css';

const ChangeSiteMainPhoto = ({ closeModal, id, onSuccess }) => {
    const { openTimeModal } = useTimeModal();

    const [position, setPosition] = React.useState('');
    const [isMain, setIsMain] = React.useState('');
    const [loading, setLoading] = React.useState(true);
    const [warning, setWarning] = React.useState('');
    const [status, setStatus] = React.useState('');

    React.useEffect(() => {
        document.body.style.overflow = 'hidden';

        return () => {
        document.body.style.overflow = '';
        };
    }, []);

    React.useEffect(() => {
        const token = localStorage.getItem('token');

        axios.get(`/api/get-photo-info?id=${id}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        })
        .then((response) => {
            setWarning('');
            setPosition(response.data.position);
            setIsMain(response.data.is_main);
        })
        .catch((error) => {
          setWarning(`${error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}`);
        })
        .finally(() => {
            setLoading(false);
        });
    }, []);

    const changePhoto = () => {
    
        axios.put('/api/change-photo', {
            position: position,
            is_main: isMain,
            id: id
        })
        .then(() => {
            setStatus('Настройки фотографии успешно изменены');
            onSuccess();
            closeModal();
        })
        .catch((error) => {
          setStatus(`${error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}`);
        });
    };
    const deletePhoto = () => {
        axios.delete('/api/delete-photo', { data: { id } })
        .then(() => {
            openTimeModal('Фотография удалена', 'success');
            onSuccess();
            closeModal();
        })
        .catch(() => {
            openTimeModal('Ошибка удаления фотографии', 'error');
        });
    };
    

    return (
        <div className={styles.liningOver}>
        <div className={styles.lining} onClick={(e) => e.stopPropagation()}>
            <div className={styles.header}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <h1>Настройки фотографии</h1>
            </div>
            <svg onClick={() => { closeModal(); }} viewBox="0 0 24 24" fill="none">
                <path fillRule="evenodd" clipRule="evenodd" d="M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L12 10.5858L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L13.4142 12L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L12 13.4142L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.68342 5.29289 17.2929L10.5858 12L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z" fill="#000000" />
            </svg>
            </div>
            <div className={styles.main}>
            {loading ? <Loading />
            : <>
                {isMain === 0 ?
                <>
                <a>Позиция отображения:</a>
                <input
                    type="number"
                    placeholder="Позиция отображения"
                    min="0"
                    value={position}
                    onChange={(e) => {
                        const value = e.target.value;
                        if (value === '' || Number(value) >= 0) {
                        setPosition(value);
                        }
                    }}
                    required
                />
                </>
                :
                <></>}
                <a>Является главной фотографией сайта:</a>
                <select
                    value={isMain}
                    onChange={(e) => setIsMain(e.target.value)}
                    style={{marginBottom: '20px'}}
                    required
                >
                    <option value="" disabled>Выберите вариант</option>
                    <option value="1">Является</option>
                    <option value="0">Не является</option>
                </select>
                {status && <a className={styles.statusPanel}><img src="/img/icons/warning-icon.svg" alt="Предупреждение" />{status}</a>}
                <div style={{display: 'flex', justifyContent: 'end', gap: '15px', alignItems: 'center'}}>
                    <button className="button maxWidth red" onClick={() => deletePhoto()}>Удалить</button>
                    <button className="button maxWidth black" onClick={() => changePhoto()}>Изменить</button>
                </div>
            </>}
            </div>
        </div>
        </div>
    );
};

export default ChangeSiteMainPhoto;
